import { Placement } from '@ori/analytics-data';
import { useEnvironment } from '@ori/environment';
import { QuickBuyButton } from '@ori/presentation-components';
import useTestId from '@ori/testid-generator';
import { type FC } from 'react';

import { SearchPreviewImage } from '../SearchPreviewImage';
import { Prices, ProductInfo } from './components';
import { SEARCH_PREVIEW_PRODUCT } from './constants';
import { Info, Inner, Price, PriceAndButton, Root } from './styles';
import { type SearchPreviewProductProps } from './types';

export const SearchPreviewProduct: FC<SearchPreviewProductProps> = ({
  index,
  code,
  name,
  brand,
  image,
  deal,
  ppa,
  onProductClick,
  onQuickBuyButtonClick,
  price,
  searchPhrase,
  canBeSold = true,
  shades,
}) => {
  const { getTestId } = useTestId();
  const { tenant } = useEnvironment();

  return (
    <Root
      data-testid={getTestId(SEARCH_PREVIEW_PRODUCT)}
      onClick={onProductClick}
    >
      <SearchPreviewImage
        name={name}
        imageUrl={image}
      />
      <Inner>
        <Info>
          <ProductInfo
            brand={brand}
            name={name}
            searchPhrase={searchPhrase}
            shades={shades}
            code={code}
            deal={deal}
            ppa={ppa}
          />
        </Info>
        <PriceAndButton>
          <Price>
            <Prices
              price={price}
              code={code}
            />
          </Price>
          {canBeSold ? (
            <QuickBuyButton
              tenant={tenant}
              currentProductCode={code}
              name={name}
              placement={Placement.TopNavigationSearchSuggestions}
              currentPrice={price?.currentFormatted ?? ''}
              position={index}
              onQuickBuyButtonClick={onQuickBuyButtonClick}
            />
          ) : null}
        </PriceAndButton>
      </Inner>
    </Root>
  );
};
